/**
 * Remove accents from a string.
 *
 * @param {string} str - The string to remove accents from.
 * @returns {string} The string without accents.
 */
const removeAccents = (str) => String(str).normalize('NFD').replace(/[\u0300-\u036f]/g, '')

/**
 * Filters an array of rows based on a search query.
 *
 * @param {Array} rows - The array of rows to be filtered. Defaults to an empty array.
 * @param {string} inputValue - The search query. Defaults to an empty string.
 * @return {Array} The filtered array of rows.
 */

export const filterRegisters = (rows = [], inputValue = '') => {
  if (!inputValue) return rows
  let words = removeAccents(inputValue).toLowerCase().split(' ')

  return rows.filter(
    row => words.every(
      word => Object.keys(row).some(key => removeAccents(String(row[key])).toLowerCase().includes(word))
    )
  )
}

/**
 * Filters an option based on a search query.
 *
 * @param {string} input - The search query.
 * @param {Object} option - The option to be filtered.
 * @return {boolean} True if the option matches the search query, false otherwise.
 */
export const filterOption = (input, option) => {
  if (!input) return true
  const words = removeAccents(input).toLowerCase().split(' ')
  const label = removeAccents(option.label).toLowerCase()
  return words.every(word => label.includes(word))
}